import ContentContainer from 'components/content-container/ContentContainer';
import Link from 'components/link/Link';
import Message from 'components/message/Message';
import TibiProposalData from './TibiProposalData';
import TimelineHorizontal from 'components/timeline-horizontal/TimelineHorizontal';
import Icon from 'components/icon/Icon';
import OptionsModal from 'components/options-modal/OptionsModal';
import ArticleHeader from 'components/article-header/ArticleHeader';
import TimelineVertical from 'components/timeline-vertical/TimelineVertical';
import Tabs from 'components/tabs/Tabs';
import Status from 'components/status/Status';
import ContentArea from 'components/content-area/ContentArea';
import RichText from 'components/rich-text/RichText';
import Announcement from 'components/announcement/Announcement';
import StepTag from 'components/step-tag/StepTag';

import { ITibiProposalPage, Status_Theme } from 'source/NFR.types';

const TibiProposalPage: React.FC<ITibiProposalPage> = ({
  applyButton,
  contacts,
  contactLabel,
  download,
  metaDataTitle,
  metadataLeft,
  arbitraryMetadata,
  metadataRight,
  message,
  tabs,
  title,
  preamble,
  timelineHorizontal,
  headerContentArea,
  footerContentArea,
  applicationSystemTag,
  goBack,
  isInternational,
  statusList,
  header,
  timelineVertical,
  siblings
}) => (
  <div className="tibi-proposal-page">
    <ContentContainer>
      {goBack && (
        <a href={goBack.url} className="button button--theme-secondary tibi-proposal-page__back-button">
          <Icon name="arrow-down" />
          {goBack.text}
        </a>
      )}
      {(applicationSystemTag || siblings?.groupTag) && (
        <div className="tibi-proposal-page__step-tags">
          {applicationSystemTag && <StepTag label={applicationSystemTag} variant="application-system" />}
          {siblings?.groupTag && <StepTag label={siblings.groupTag} />}
        </div>
      )}
      {statusList && (
        <div className="tibi-proposal-page__status-container">
          {statusList?.map(status => (
            <Status key={status.text} text={status.text} theme={status.theme as unknown as Status_Theme} />
          ))}
        </div>
      )}
      {title && (
        <h1 className="tibi-proposal-page--heading" data-epi-type="title">
          {isInternational && <Icon className="tibi-proposal-page--icon" name="globe"></Icon>}
          {title}
        </h1>
      )}
      {preamble && (
        <div className="tibi-proposal-page--preamble" data-epi-type="content">
          <RichText {...preamble} />
        </div>
      )}
    </ContentContainer>
    <ContentContainer>{siblings && siblings.links.length > 0 && <Announcement {...siblings} />}</ContentContainer>

    <div className="tibi-proposal-page--header">
      <ContentContainer className="tibi-proposal-page__header-container">
        {header && <ArticleHeader {...header} />}
        {metaDataTitle && <h2 className="tibi-proposal-page--header-preamble">{metaDataTitle}</h2>}
        <div className="tibi-proposal-data" data-epi-type="content">
          <TibiProposalData {...metadataLeft} />
          <TibiProposalData {...metadataRight} contacts={contacts} contactLabel={contactLabel} rightColumn={true} />
        </div>
        {arbitraryMetadata?.items && arbitraryMetadata.items.length > 0 && (
          <div className="tibi-proposal-data" data-epi-type="content">
            <TibiProposalData {...arbitraryMetadata} arbitrary={true} />
          </div>
        )}

        <div className="tibi-proposal-page--header-actions">
          <Link className="tibi-proposal-page--apply-button" theme="primary" useButtonStyles {...applyButton} />
          {download && (
            <OptionsModal className="tibi-proposal-page--download" theme="isProposalOrEvent" {...download} />
          )}
        </div>
      </ContentContainer>
    </div>
    {message && (
      <ContentContainer className="proposal-page--message-container">
        <Message {...message} />
      </ContentContainer>
    )}
    {timelineHorizontal && <TimelineHorizontal {...timelineHorizontal} />}
    {timelineVertical && <TimelineVertical isBlock={false} {...timelineVertical} />}
    {/* content-container above tabs */}
    <ContentContainer>
      <ContentArea className="tibi-proposal-page--top-content-area" {...headerContentArea} />
    </ContentContainer>
    {/* main content */}
    {tabs && <Tabs {...tabs} />}
    {/* content-container below tabs */}
    <ContentContainer>
      <ContentArea className="tibi-proposal-page--bottom-content-area" {...footerContentArea} />
    </ContentContainer>
  </div>
);

TibiProposalPage.displayName = 'TibiProposalPage';

export default TibiProposalPage;
